import React from 'react';

const GridItem = ({ href, image, topline, headline, subline }) => (
    <a className="griditem" href={href}>
        {image
            ? <img src={image}/>
            : <div className="griditem_dummy"></div>
        }
        <div className="griditem_content_text">
            <h2 class="hl3">{ headline }</h2>
            <p className="topline">{ topline }</p>
            <p className="subline">{ subline }</p>
        </div>
    </a>
);

export default GridItem;
